// extracted by mini-css-extract-plugin
export var text = "_3p-0";